/**
 * @author        yontaek@zumper.com (Yon Taek Chung)
 * @copyright     Copyright (c) 2023, Zumper
 */

export const ALERT_CREATION_TOAST_TYPE = {
  CREATING_SEARCH: '@@nzr/toasts/CREATING_SEARCH',
  NOTIFICATION_CREATED: '@@nzr/toasts/NOTIFICATION_CREATED',
  SEARCH_SAVED: '@@nzr/toasts/SEARCH_SAVED',
  MAX_SEARCH: '@@nzr/toasts/MAX_SEARCH',
  MESSAGE_SENT: '@@nzr/toasts/MESSAGE_SENT',
} as const
